import moment from 'moment';
import Transformer from '../Transformer';

const DEFAULT_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';


export default class SubscriptionTransformer extends Transformer {
  /**
   * Method used to transform a fetched account.
   *
   * @param subscription The fetched subscription.
   *
   * @returns {Object} The transformed account.
   */
  static fetch(subscription) {
    // eslint-disable-next-line no-param-reassign
    subscription.start = moment(subscription.start, DEFAULT_DATETIME_FORMAT);
    // eslint-disable-next-line no-param-reassign
    subscription.end = moment(subscription.end, DEFAULT_DATETIME_FORMAT);
    return subscription;
  }

  /**
   * Method used to transform a send account.
   *
   * @param subscription The subscription to be send.
   *
   * @returns {Object} The transformed account.
   */
  // eslint-disable-next-line no-unused-vars
  static send(subscription) {
    return {};
  }
}
